export default __webpack_public_path__ + "static/media/Plus.e37ab5ee.svg";